import { loadScript } from '@buzzfeed/bf-utils/lib/load-script';
import { logTrackingEvents } from '../utils';

import { COMSCORE_TRACKER_NAME } from '../../constants';

const COMSCORE_CLIENT_ID = 6768151;
const BEACON_DATA = {
  c1: 2,
  c2: COMSCORE_CLIENT_ID,
};
export class ComscoreTracker {

  /**
   * @param {Number} arg.extraParams.cs_ucfr - Either 1 or 0 if consent is known, otherwise this can be omitted
   */
  constructor({ cluster, extraParams = {} }) {

    if (typeof window === 'undefined') {
      return () => {};
    }

    if (cluster !== 'prod') {
      window[COMSCORE_TRACKER_NAME] = {
        beacon: beaconData => logTrackingEvents('Comscore', beaconData)
      };
    }

    this._trackData(extraParams);
  }

  async _trackData(extraParams) {
    if (!window[COMSCORE_TRACKER_NAME]) {
      await loadScript(`https://sb.scorecardresearch.com/cs/${COMSCORE_CLIENT_ID}/beacon.js`);
    }

    if (window[COMSCORE_TRACKER_NAME]) {
      window[COMSCORE_TRACKER_NAME].beacon({ ...BEACON_DATA, ...extraParams });
    }
  }
}
